import { constants } from '../utils'
import base from './base'

const { headers, url, request } = base

const getAllCustomerCities = async () =>
  request(url(constants.api.customer.cities), {
    method: 'GET',
    headers: headers(),
  })

const customerApi = {
  getAllCustomerCities,
}

export default customerApi
